


const chartColor = require('../../../../../components/chart/chart-color')


///format data
export function barsimple(data) {
	try {
		let result = {};

		let values = [];
		let labels = [];

		for (let index = 0; index < 6; index++) {
			let amount = data[index];

			if (amount != undefined) {
				values.push(data[index].y);
				labels.push(data[index].x);
			}

		}
		
		let dataset =[{
            label: '', // Puedes ajustar este label según sea necesario
            data: values, // Los valores en Y que recibes como parámetro
            backgroundColor: [
				chartColor.getOnlyBackgroundColor('green',0.3),// Paid Incomes
				chartColor.getOnlyBackgroundColor('green',0.5),// Incomes
                chartColor.getOnlyBackgroundColor('red',0.3),  // Paid Expenses
                chartColor.getOnlyBackgroundColor('red',0.5),  // Expenses
                chartColor.getOnlyBackgroundColor('blue',0.3), // Paid Earning
                chartColor.getOnlyBackgroundColor('blue',0.5)  // Earning
            ],
            borderColor: [
				chartColor.getOnlyBorderColor('green',1),// Paid Incomes
				chartColor.getOnlyBorderColor('green',1),// Incomes
                chartColor.getOnlyBorderColor('red',1),  // Paid Expenses
                chartColor.getOnlyBorderColor('red',1),  // Expenses
                chartColor.getOnlyBorderColor('blue',1), // Paid Earning
                chartColor.getOnlyBorderColor('blue',1)  // Earning
            ],
            borderWidth: 2,
            borderRadius: 0,
            maxBarThickness: 92,
        }];

		result = {labels: labels, dataset:dataset }

		return result;



	} catch (err) { throw err; }//console.log('err', err) }
}/*createAllChart*/


function createDataset(yValues) {
    return {
        datasets: [{
            label: 'Amount', // Puedes ajustar este label según sea necesario
            data: yValues, // Los valores en Y que recibes como parámetro
            backgroundColor: [
                'rgba(255, 99, 132, 0.80)', // Color para la primera barra
                'rgba(54, 162, 235, 0.80)', // Color para la segunda barra
                'rgba(75, 192, 192, 0.80)'  // Color para la tercera barra
            ],
            borderColor: [
                'rgb(255, 99, 132)', // Borde para la primera barra
                'rgb(54, 162, 235)', // Borde para la segunda barra
                'rgb(75, 192, 192)'  // Borde para la tercera barra
            ],
            borderWidth: 2,
            borderRadius: 0,
            maxBarThickness: 92,
        }]
    };
}

///format data
export function piesimple(data) {
	try {

		let total = data.reduce((sum, item) => sum + parseFloat(item.y), 0);

		let colors = ['red', 'blue', 'green','yellow', 'gray'];

		

		let label = [];
		let color = [];
		let value = [];


		for (let index = 0; index < 5; index++) {
			let item = data[index];

			if (item != undefined) {
				label.push(data[index].y);
				color.push(colors[index]);
				value.push((parseFloat(data[index].y) / total * 100).toFixed(2));
			}

		}

		let result = {
			label: label,
			color: color,
			value: value
		}

		return result;



	} catch (err) { throw err; }//console.log('err', err) }
}/*createAllChart*/





